import {h} from 'preact';
import {cxMenu} from '../../styles';

const GroupLabel = ( {children} ) =>
    <li>
        <span className={cxMenu.groupLabel}>{children}</span>
    </li>;

export default GroupLabel;